import {
    apiPrivilegeMap,
    privilegeMapAdmin,
    privilegeMapAssociate,
    type PrivilegeMap,
    type PrivilegeNames,
} from "backend";
import { useProfileStore } from "../stores/profile.store";

export namespace Privilege {
    export type Map = PrivilegeMap;
    export type Names = PrivilegeNames;
}

export const privileges = {
    map: {
        admin: privilegeMapAdmin,
        associate: privilegeMapAssociate,
        api: apiPrivilegeMap,
        current: () => {
            switch (useProfileStore().data?.kind) {
                case "dev":
                case "super":
                case "admin":
                    return privilegeMapAdmin;
                case "associate":
                    return privilegeMapAssociate;
                default:
                    throw new Error("unexpected user kind");
            }
        },
    },
    has: (name: Privilege.Names) => {
        return useProfileStore().data?.privileges?.has(name) === true;
    },
    includes: (names: Privilege.Names[]) => {
        const privileges = useProfileStore().data?.privileges;
        if (privileges === undefined) return false;
        return new Set(names).intersection(privileges).size > 0;
    },
    formMode: (
        name: Privilege.Names,
        mode: "update" | "remove" = "update",
    ): "update" | "remove" | "static" => {
        if (privileges.has(name)) {
            return mode;
        } else {
            return "static";
        }
    },
    create: (map: Privilege.Map) => {
        const result = {} as Record<string, boolean>;

        Object.keys(map).forEach((k) => {
            const key = k as keyof typeof map;
            map[key].privileges.forEach((p) => {
                result[`${key}.${p.name}`] = false;
            });
        });

        return result;
    },
    serialize: (privileges: Record<string, boolean>) => {
        return Object.keys(privileges)
            .filter((k) => privileges[k] === true)
            .map((k) => k) as PrivilegeNames[];
    },
    deserialize: (privileges: string[]): Record<string, boolean> => {
        return privileges.reduce((a, v) => ({ ...a, [v]: true }), {});
    },
};
